/* Pinflag------------------------------------- */
// Función para agregar al carrito
const addToCartP = (variantId, button) => {
  axios
    .post("/cart/add.js", {
      id: variantId,
      quantity: 1,
    })
    .then((response) => {
      const span = button.querySelector("span");
      if (span) {
        span.textContent = "AÑADIR AL CARRO";
      }

      document.querySelector("#show-cart").click();
    })
    .catch((error) => {
      console.error("Error al agregar al carrito:", error);
    });
};

document.querySelectorAll(".variant-button").forEach((button) => {
  button.addEventListener("click", handleVariantClick);
});

function handleVariantClick(event) {
  const button = event.target.closest(".variant-button");
  if (!button) return;

  const card = button.closest(".product-variant-selector");
  const buttons = card.querySelectorAll(".variant-button");

  buttons.forEach((btn) => btn.classList.remove("selected"));

  console.log("event", event);

  button.classList.add("selected");
}

const cont = document.querySelector(".product-list");

if (cont) {
  cont.addEventListener("click", handleVariantClick);
}

function aplicarBotonesAddToCart() {
  document
    .querySelectorAll(".product-variant-selector:not(.cart-initialized)")
    .forEach((card) => {
      card.classList.add("cart-initialized");

      const button = card.querySelector(".add-to-cart-button");
      if (!button) return;

      button.addEventListener("click", (event) => {
        const span = button.querySelector("span");
        if (span) {
          span.textContent = "Añadiendo...";
        }

        const selectedVariant = card.querySelector(".variant-button.selected");

        if (selectedVariant) {
          const variantId = selectedVariant.getAttribute("data-variant-id");
          addToCartP(variantId, button);
        }
      });
    });
}

// Aplica al cargar
aplicarBotonesAddToCart();

// Observa nuevos productos en .product-list
const cont2 = document.querySelector(".product-list");

if (cont2) {
  const observer = new MutationObserver(() => {
    aplicarBotonesAddToCart();
  });

  observer.observe(cont2, {
    childList: true,
    subtree: true,
  });
}

function aplicarLogicaBotones(card) {
  const selectSizeButton = card.querySelector(".select-size-button");
  const addToCartButton = card.querySelector(".add-to-cart-button");
  const closeButton = card.querySelector(".close-variants-buttons");
  const variantButtons = card.querySelector(".variant-buttons");

  if (!selectSizeButton || !addToCartButton || !closeButton || !variantButtons)
    return;

  selectSizeButton.addEventListener("click", () => {
    addToCartButton.setAttribute("style", "display: flex !important;");
    selectSizeButton.setAttribute("style", "display: none !important;");
    variantButtons.setAttribute("style", "display: flex !important;");
  });

  closeButton.addEventListener("click", () => {
    addToCartButton.setAttribute("style", "display: none !important;");
    selectSizeButton.setAttribute("style", "display: flex !important;");
    variantButtons.setAttribute("style", "display: none !important;");
  });
}

function aplicarALosExistentes() {
  document
    .querySelectorAll(".product-variant-selector:not(.initialized)")
    .forEach((card) => {
      card.classList.add("initialized");
      aplicarLogicaBotones(card);
    });
}

// Aplica al inicio
aplicarALosExistentes();

// Observador para cargas nuevas
const contenedor = document.querySelector(".product-list");
if (contenedor) {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          // Si el nodo agregado es un .product-variant-selector directo
          if (node.matches(".product-variant-selector")) {
            if (!node.classList.contains("initialized")) {
              node.classList.add("initialized");
              aplicarLogicaBotones(node);
            }
          }

          // Si contiene dentro uno o más .product-variant-selector
          node
            .querySelectorAll?.(".product-variant-selector:not(.initialized)")
            .forEach((card) => {
              card.classList.add("initialized");
              aplicarLogicaBotones(card);
            });
        }
      });
    }
  });

  observer.observe(contenedor, {
    childList: true,
    subtree: true,
  });
}

////////////////// OBSERVER CAMBIO FILTRO ////////////////

document.addEventListener("DOMContentLoaded", () => {
  // Seleccionar el contenedor de la lista de productos
  const productList = document.querySelector(".filters-results");

  if (productList) {
    // Configuración del observer: observar cambios en los hijos (productos)
    const config = { childList: true, subtree: false };

    // Callback que se ejecuta cuando hay cambios en los productos
    const callback = (mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList") {
          console.log("recargué");
          // Llamar aquí al script que necesitas ejecutar
          reloadScript();
        }
      }
    };

    // Crear e inicializar el observer
    const observer = new MutationObserver(callback);
    observer.observe(productList, config);
  } else {
    console.warn("No se encontró el contenedor .product-list");
  }
});

// Función que se ejecuta cuando hay un cambio en la lista de productos
function reloadScript() {
  document.querySelectorAll(".product-variant-selector").forEach((card) => {
    const selectSizeButton = card.querySelector(".select-size-button");
    const addToCartButton = card.querySelector(".add-to-cart-button");

    const closeButton = card.querySelector(".close-variants-buttons");
    const variantButtons = card.querySelector(".variant-buttons");

    selectSizeButton.addEventListener("click", () => {
      if (addToCartButton) {
        addToCartButton.setAttribute("style", "display: flex !important;");
        selectSizeButton.setAttribute("style", "display: none !important;");
        variantButtons.setAttribute("style", "display: flex !important;");
      }
    });

    closeButton.addEventListener("click", () => {
      if (variantButtons) {
        addToCartButton.setAttribute("style", "display: none !important;");
        selectSizeButton.setAttribute("style", "display: flex !important;");
        variantButtons.setAttribute("style", "display: none !important;");
      }
    });
  });

  document.querySelectorAll(".variant-button").forEach((button) => {
    button.addEventListener("click", handleVariantClick);
  });

  document.querySelectorAll(".product-variant-selector").forEach((card) => {
    const selectSizeButton = card.querySelector(".select-size-button");
    const addToCartButton = card.querySelector(".add-to-cart-button");

    const closeButton = card.querySelector(".close-variants-buttons");
    const variantButtons = card.querySelector(".variant-buttons");

    selectSizeButton.addEventListener("click", () => {
      if (addToCartButton) {
        addToCartButton.setAttribute("style", "display: flex !important;");
        selectSizeButton.setAttribute("style", "display: none !important;");
        variantButtons.setAttribute("style", "display: flex !important;");
      }
    });

    closeButton.addEventListener("click", () => {
      if (variantButtons) {
        addToCartButton.setAttribute("style", "display: none !important;");
        selectSizeButton.setAttribute("style", "display: flex !important;");
        variantButtons.setAttribute("style", "display: none !important;");
      }
    });
  });

  document.querySelectorAll(".product-variant-selector").forEach((card) => {
    const button = card.querySelector(".add-to-cart-button");

    button.addEventListener(
      "click",
      (event) => {
        const span = button.querySelector("span");
        if (span) {
          span.textContent = "Añadiendo...";
        }

        const selectedVariant = card.querySelector(".variant-button.selected");

        if (selectedVariant) {
          const variantId = selectedVariant.getAttribute("data-variant-id");
          addToCartP(variantId, button);
        }
      },
      { once: false }
    );
  });

  const addToCartP = (variantId, button) => {
    axios
      .post("/cart/add.js", {
        id: variantId,
        quantity: 1,
      })
      .then((response) => {
        const span = button.querySelector("span");
        if (span) {
          span.textContent = "AÑADIR AL CARRO";
        }

        document.querySelector("#show-cart").click();
      })
      .catch((error) => {
        console.error("Error al agregar al carrito:", error);
      });
  };
}

function initializeCarousels() {
  document.querySelectorAll(".imagenes_plp").forEach(function (plp) {
    if (plp.hasAttribute("data-carousel-initialized")) return;
    plp.setAttribute("data-carousel-initialized", "true");

    const wrapper = plp.querySelector(".carousel-wrapper");
    const items = plp.querySelectorAll(".carousel-item");
    const btnNext = plp.querySelector(".carousel-btn.next");
    const btnPrev = plp.querySelector(".carousel-btn.prev");

    let currentIndex = 1;
    const totalItems = items.length;

    // Clonar primer y último item
    const firstClone = items[0].cloneNode(true);
    const lastClone = items[totalItems - 1].cloneNode(true);

    wrapper.appendChild(firstClone);
    wrapper.insertBefore(lastClone, items[0]);

    const allItems = wrapper.querySelectorAll(".carousel-item");

    wrapper.style.transform = `translateX(-100%)`; // Mostrar el primer "real"
    wrapper.style.transition = "transform 0.3s ease-in-out";

    function moveCarousel() {
      wrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
    }

    function nextItem() {
      currentIndex++;
      moveCarousel();
      wrapper.addEventListener("transitionend", handleLoopForward, {
        once: true,
      });
    }

    function prevItem() {
      currentIndex--;
      moveCarousel();
      wrapper.addEventListener("transitionend", handleLoopBackward, {
        once: true,
      });
    }

    function handleLoopForward() {
      if (currentIndex === totalItems + 1) {
        wrapper.style.transition = "none";
        currentIndex = 1;
        wrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
        setTimeout(
          () => (wrapper.style.transition = "transform 0.3s ease-in-out")
        );
      }
    }

    function handleLoopBackward() {
      if (currentIndex === 0) {
        wrapper.style.transition = "none";
        currentIndex = totalItems;
        wrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
        setTimeout(
          () => (wrapper.style.transition = "transform 0.3s ease-in-out")
        );
      }
    }

    // Touch events
    let startX = 0;
    let isDragging = false;

    wrapper.addEventListener("touchstart", (e) => {
      startX = e.touches[0].pageX;
      isDragging = true;
    });

    wrapper.addEventListener("touchmove", (e) => {
      if (!isDragging) return;
      const moveX = e.touches[0].pageX - startX;
      if (Math.abs(moveX) > 50) {
        moveX > 0 ? prevItem() : nextItem();
        isDragging = false;
      }
    });

    wrapper.addEventListener("touchend", () => (isDragging = false));

    if (btnNext) btnNext.addEventListener("click", nextItem);
    if (btnPrev) btnPrev.addEventListener("click", prevItem);
  });
}

// Inicializar al cargar la página
document.addEventListener("DOMContentLoaded", initializeCarousels);

// Observer para detectar cuando se agregan nuevos productos
const observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
      // Verificar si se agregaron nodos que contienen carruseles
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Si el nodo agregado contiene carruseles o es un carrusel
          if (
            node.querySelector &&
            (node.querySelector(".imagenes_plp") ||
              node.classList.contains("imagenes_plp"))
          ) {
            initializeCarousels();
          }
        }
      });
    }
  });
});

// Observar cambios en .filters-results
document.addEventListener("DOMContentLoaded", function () {
  const filtersResults = document.querySelector(".filters-results");
  if (filtersResults) {
    observer.observe(filtersResults, {
      childList: true,
      subtree: true,
    });
  }
});

// CORRECCIÓN CART - RELACIONADOS (APP UPSELLS)//

document.addEventListener("DOMContentLoaded", () => {
  document.body.addEventListener("click", (event) => {
    const button = event.target.closest(
      '[data-essential-upsell-element="add-to-cart-button"]'
    );

    if (button) {
      setTimeout(() => {
        const panel = document.getElementById("wow-cart-drawer__panel");
        const drawerButton = document.getElementById("wow-cart-drawer-button");

        if (panel && drawerButton) {
          panel.classList.remove("wow-cart-hide", "wow-cart-closed");
          drawerButton.classList.add("wow-cart-hide");
          document.body.classList.add("wow-cart-opened");
        } else {
        }
      }, 1000);
    }
  });
});
